import { css } from '@emotion/react'
import { SearchInput } from '@livechat/design-system-react-components'
import {
  AMPLITUDE_EVENTS,
  SEARCH,
} from 'gatsby-theme-marketplace-base/src/constants'

// @ts-expect-error
import { useEnhancedList } from 'gatsby-theme-marketplace-base/src/context/EnhancedList'
import { useTypedDispatch } from 'gatsby-theme-marketplace-base/src/store/hooks'
// @ts-expect-error
import { logAmplitudeEvent } from 'gatsby-theme-marketplace-base/src/store/stats'

const searchCss = css`
  width: 180px;
`

export const Search = () => {
  const { query, updateSearch, section } = useEnhancedList()
  const dispatch = useTypedDispatch()

  if (!SEARCH.ENABLED_SECTIONS.includes(section)) {
    return null
  }

  return (
    <SearchInput
      css={searchCss}
      value={query}
      onChange={updateSearch}
      placeholder={`Search for ${section}`}
      onFocus={() =>
        dispatch(
          logAmplitudeEvent({
            name: AMPLITUDE_EVENTS.SEARCH_FOCUSED,
          })
        )
      }
    />
  )
}
